import React, { Component } from 'react';

class Header extends Component {
  render() {
    return (
      <header className="mb-header">
        <div className="mb-title">Marbleer</div>
        {window.loginController.loggedIn ? (
            <div
                className="mb-right"
                onClick={window.loginController.logout}
            >Logout</div>
            ) : (
            <div
                className="mb-right"
                onClick={window.loginController.login}
            >Login</div>
        )}
      </header>
    )
  }
}

export default Header; // Don’t forget to use export default!


// WEBPACK FOOTER //
// ./src/Header.js